// extracted by mini-css-extract-plugin
export var date = "NewsItem-module--date--3cd9e";
export var fadeInAnimation = "NewsItem-module--fadeInAnimation--52180";
export var item = "NewsItem-module--item--98ff8";
export var itemWrapper = "NewsItem-module--itemWrapper--7338a";
export var link = "NewsItem-module--link--fd0e6";
export var linkText = "NewsItem-module--linkText--05033";
export var linkTitle = "NewsItem-module--linkTitle--83577";
export var title = "NewsItem-module--title--b4ebe";